import React, { useLayoutEffect, useRef } from 'react';
import { defaultedMarkdownLinkTargetOptions } from '../markdown/markdownLinkTargetOptions';
export const markdownLinkTargetMiddleware = (_options) => () => (next) => (...args) => {
    const options = defaultedMarkdownLinkTargetOptions(_options || {});
    const [{ activity }] = args;
    const render = next(...args);
    if (activity.type === 'message' && render) {
        return (...children) => {
            const wrapperEl = useRef(null);
            useLayoutEffect(() => {
                var _a;
                (_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[aria-roledescription=message]').forEach((e, i) => {
                    e.querySelectorAll('a').forEach((anchor) => {
                        if (anchor.classList.contains(options.externalLinkClass)) {
                            anchor.target = options.externalLinkTarget;
                        }
                        else if (anchor.classList.contains(options.internalLinkClass)) {
                            anchor.target = options.internalLinkTarget;
                        }
                    });
                });
            });
            return React.createElement("div", { ref: wrapperEl }, render(...children));
        };
    }
};
//# sourceMappingURL=markdownLinkTargetMiddleware.js.map